import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useFormatContext = (matterId: string | undefined) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(async ({ question, answer }: { question: string; answer: string }) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: { question, answer },
    });
    const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/format-context`, fetchConfig);
    if (!response.ok) throw new Error('Failed to format context');
    const data: { formatted: string } = await response.json();
    return data.formatted;
  });
};
